import React from 'react';
import { motion } from 'framer-motion';
import { Check, Shield, Clock, Zap, Star } from 'lucide-react';
import { Button } from './Button';
const CHECKOUT_URL = 'https://checkout.lmpulsodigital.shop/cart/44574833836167:1';
const features = ['3 Tomos principales (I, II y III)', '6 Bonos completos', '100 Hooks Que Generan Ventas', 'Swipe Files de Anuncios', 'Prompts de IA Para Marketing', 'Plantillas de Reels', '+100 CTA Que Convierten', 'Calendario de Contenido Estratégico', 'Sistema de Diagnóstico de Contenido', 'Acceso de por vida', 'Actualizaciones gratuitas'];
export const Pricing = () => {
  return <section id="pricing" className="py-14 md:py-24 bg-brand-dark relative scroll-mt-10" data-id="element-114">
      <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-brand-gold/5 via-brand-dark to-brand-dark pointer-events-none" data-id="element-115" />

      <div className="container px-4 mx-auto max-w-3xl relative z-10" data-id="element-116">
        {/* Urgency Block */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-8 md:mb-12 text-center" data-id="element-117">
          <div className="inline-flex items-center gap-2 px-4 py-2 mb-4 md:mb-6 text-xs md:text-sm font-bold text-red-500 border border-red-500/30 rounded-full bg-red-500/10" data-id="element-118">
            🔥 Promoción por tiempo limitado 🔥
          </div>
          <h2 className="mb-3 md:mb-4 text-3xl font-bold md:text-5xl" data-id="element-119">
            Accedé hoy mismo
          </h2>
          <p className="text-gray-400 mb-4 md:mb-6 text-sm md:text-base" data-id="element-120">
            Acceso inmediato y de por vida. Pago único, sin suscripciones.
          </p>

          <div className="bg-brand-card p-4 rounded-xl border border-white/5 max-w-xl mx-auto" data-id="element-121">
            <div className="flex justify-between text-sm mb-2 font-medium" data-id="element-122">
              <span className="text-brand-gold" data-id="element-123">
                Cupos disponibles agotándose
              </span>
              <span className="text-white" data-id="element-124">80% tomados</span>
            </div>
            <div className="w-full bg-brand-dark rounded-full h-2.5" data-id="element-125">
              <div className="bg-gold-gradient h-2.5 rounded-full" style={{
              width: '80%'
            }} data-id="element-126"></div>
            </div>
            <p className="text-xs text-gray-500 mt-3" data-id="element-127">
              Últimos cupos a precio promocional. Una vez agotados, vuelve al
              precio original.
            </p>
          </div>
        </motion.div>

        {/* Single Pricing Card */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="relative p-6 md:p-12 border-2 bg-brand-card rounded-3xl border-brand-gold glow-gold mb-8 md:mb-12" data-id="element-128">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2" data-id="element-129">
            <span className="bg-gold-gradient text-black text-xs font-bold px-4 py-1.5 rounded-full flex items-center gap-1 uppercase tracking-wider" data-id="element-130">
              <Star className="w-3 h-3 fill-black" data-id="element-131" /> Oferta exclusiva
            </span>
          </div>

          <div className="text-center mb-6 md:mb-8" data-id="element-132">
            <h3 className="text-2xl md:text-3xl font-bold text-brand-gold mb-2" data-id="element-133">
              MARKETING PRO
            </h3>
            <p className="text-gray-400 mb-4 md:mb-6 text-sm md:text-base" data-id="element-134">
              Acceso completo al sistema
            </p>

            <div className="flex items-baseline justify-center gap-3 mb-2" data-id="element-135">
              <span className="text-xl md:text-2xl text-gray-500 line-through" data-id="element-136">
                $59.990
              </span>
              <span className="text-5xl md:text-7xl font-bold text-white" data-id="element-137">
                $19.990
              </span>
            </div>
            <span className="inline-block bg-green-500/20 text-green-400 text-xs font-bold px-3 py-1 rounded-full border border-green-500/30" data-id="element-138">
              AHORRÁS $40.000
            </span>
          </div>

          <ul className="space-y-2 md:space-y-3 mb-6 md:mb-10 max-w-md mx-auto" data-id="element-139">
            {features.map((feature, i) => <li key={i} className="flex items-start gap-3 text-white" data-id="element-140">
                <Check className="w-5 h-5 text-brand-gold shrink-0 mt-0.5" data-id="element-141" />
                <span data-id="element-142">{feature}</span>
              </li>)}
          </ul>

          <div className="flex flex-col items-center" data-id="element-143">
            <Button href={CHECKOUT_URL} className="w-full md:w-auto md:px-12 text-lg md:text-xl" data-id="element-144">
              SÍ, QUIERO ACCEDER AHORA
            </Button>
            <p className="text-xs text-center text-gray-400 mt-4 max-w-md" data-id="element-145">
              Pago seguro vía Mercado Pago. Acceso inmediato luego de la compra.
            </p>
          </div>
        </motion.div>

        {/* Trust Badges */}
        <div className="flex flex-wrap justify-center gap-6 md:gap-12 pt-8 border-t border-white/10" data-id="element-146">
          <div className="flex items-center gap-2 text-sm text-gray-400" data-id="element-147">
            <Shield className="w-5 h-5 text-brand-gold" data-id="element-148" /> Pago seguro
          </div>
          <div className="flex items-center gap-2 text-sm text-gray-400" data-id="element-149">
            <Zap className="w-5 h-5 text-brand-gold" data-id="element-150" /> Acceso en 5 min
          </div>
          <div className="flex items-center gap-2 text-sm text-gray-400" data-id="element-151">
            <Clock className="w-5 h-5 text-brand-gold" data-id="element-152" /> Garantía 7 días
          </div>
          <div className="flex items-center gap-2 text-sm text-gray-400 font-bold" data-id="element-153">
            Mercado Pago
          </div>
        </div>
      </div>
    </section>;
};